import { Em } from "../types"

export const targetWidths = new WeakMap<HTMLElement, Em>()
